export enum NotificationType {
	Event = 'event',
	OpenMarket = 'openMarket',
	GameStatus = 'gameStatus',
	ProbabilityAchievement = 'probabilityAchievement',
	NewsfeedArticle = 'newsfeedArticle',
}
